<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.7155 5.64655L13.25 8L10.7155 10.3534M13.069 8H7.09483M10.3534 2.75H4.19828C3.39841 2.75 2.75 3.39841 2.75 4.19828V11.8017C2.75 12.6016 3.39841 13.25 4.19828 13.25H10.3534" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
